import { SearchLockedUser } from './locked-users/locked-users.component';
import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AppConfigService } from 'src/app/services/app-config.service';

@Injectable({
  providedIn: 'root'
})
export class LockedUsersService {
  private apiUrl: string;
  private apiEndpoint: string;

  constructor(private _http: HttpClient, 
              private _appConfig: AppConfigService) {
    this.apiUrl = _appConfig.config.servicesBaseUrl;                
    this.apiEndpoint = this.apiUrl + "/adm/locked-users";
  }

  findLockedUsers(searchLockedUser: SearchLockedUser,  page: number, size: number, sortBy:string, order: string): Observable<any> {
    let url = `${this.apiEndpoint}/?page=${page}&size=${size}&sortBy=${sortBy}&order=${order.toUpperCase()}`;
    return this._http.post<any>(url, searchLockedUser);
  }

  findByLogin(login: string): Observable<any> {
    let params = new HttpParams();
    return this._http.get<any>(this.apiEndpoint + "/" + login, { params, observe: 'response' });
  }

  unlockUser(compteKey: number) {
    return this._http.put(this.apiEndpoint + '/unlock/' + compteKey, null);
  }

  lockUser(compteKey: number) {
    return this._http.put(this.apiEndpoint + '/lock/' + compteKey, null);
  }

  enable(compteKey: number, enable: boolean) {
    if(enable) {
      return this._http.put(this.apiEndpoint + '/enable/' + compteKey, null);
    } 
    return this._http.put(this.apiEndpoint + '/disable/' + compteKey, null);
  }

  deleteUser(compteKey: number) {
    return this._http.delete(this.apiEndpoint + '/' + compteKey);
  }

}
